export enum ShipmentStatus {
  OPEN,
  ALLOCATED,
  CONFIRMED,
  RELEASED,
  INPROGRESS,
  RETURNED,
  CLOSED,
  INVOICED
}

export const shipmentStatusMap: Map<ShipmentStatus, string> = new Map<ShipmentStatus, string>([
  [ShipmentStatus.OPEN, "Open"],
  [ShipmentStatus.ALLOCATED, "Allocated"],
  [ShipmentStatus.CONFIRMED, "Confirmed"],
  [ShipmentStatus.RELEASED, "Released"],
  [ShipmentStatus.INPROGRESS, "InProgress"],
  [ShipmentStatus.RETURNED, "Returned"],
  [ShipmentStatus.CLOSED, "Closed"],
  [ShipmentStatus.INVOICED, "Invoiced"]
]);

export const shipmentStatusOptions = Object.keys(ShipmentStatus)
  .map(key => {
    return {
      value: [ShipmentStatus[key], "Shipment"],
      label: shipmentStatusMap.get(ShipmentStatus[key])
    }
  })
  .filter(option => !!option.label);
